/*
* @Author: xiaoyun
* @Date:   2018-06-06 21:09:42
* @Last Modified by:   xiaoyun
* @Last Modified time: 2018-06-06 21:43:20
*/
export const SET_USER_ID = 'SET_USER_ID'
export const SET_USER_NAME = 'SET_USER_NAME'
export const SET_COMPLETE_ANS = 'SET_COMPLETE_ANS'
export const SET_TASK_ID = 'SET_TASK_ID'
export const SET_BASE_INFO = 'SET_BASE_INFO'
export const SET_PROCESS_ID = 'SET_PROCESS_ID'
export const SET_NEXT_PROCESS_ID = 'SET_NEXT_PROCESS_ID'
export const SET_NODE_INFO = 'SET_NODE_INFO'
export const SET_CHECKED_USER = 'SET_CHECKED_USER'
export const SET_USER_LIST = 'SET_USER_LIST'
export const SET_COUNT = 'SET_COUNT'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js